import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { adapter } from '../providers/adapter';
import { useAuthStore } from '@/core/stores/auth.store';

export function useResetPassword() {
  const { t } = useTranslation('auth');
  const logout = useAuthStore((s) => s.logout);
  const [isPending, setIsPending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updatePassword = async (password: string): Promise<void> => {
    setIsPending(true);
    setError(null);
    try {
      await adapter.updatePassword(password);
      setIsSuccess(true);
      // La sesión temporal de recuperación queda cerrada: el usuario debe
      // volver a iniciar sesión con la contraseña nueva.
      await logout().catch(() => {});
    } catch (err) {
      setError(err instanceof Error ? err : new Error(t('errors.generic')));
    }
    setIsPending(false);
  };

  return { updatePassword, isPending, isSuccess, error };
}
